<template>
  <div>
    <h3>Brand Message</h3>
    <div class="h4 py-5">顯示於首頁</div>
    <div class="form-item d-flex flex-nowrap py-5">
      <h4 class="w-174px mr-6px h4">Title</h4>
      <div class="h4 w-540px">{{ homepage.title }} </div>
    </div>
    <div class="form-item d-flex py-5">
      <h4 class="w-174px mr-6px h4 flex-shrink-0">Description</h4>
      <div class="h4 w-540px">
        {{ homepage.description }}
      </div>
    </div>
    <div class="form-item d-flex py-5">
      <h4 class="w-174px mr-6px h4">Call To Action</h4>
      <div class="h4 w-540px">{{ homepage.call_to_action }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'homepage',
  ],
};
</script>

<style></style>
